import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'events';

export function useGetAllEvents(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetEvent(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateEvent() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateEvent({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteEvent({id}) {
    return useDelete({queryKey: [endpoint, id]});
}

export function upcomingEventDates(event) {
    //
}


/*

<span class="block" ng-repeat="date in row.dates | orderBy:'start_date' | filter: upcomingDate as results"
                    >
                        <span ng-show="eventDate.start_date | validDate">
                                {{ eventDate.start_date | amDateFormat:'L' }}
                            </span>
                            <span ng-show="eventDate.start_time != null"> {{ eventDate.start_time | amDateFormat:'hh:mma' }} </span>
                            <span ng-show="(eventDate.start_date | validDate) &&
                                           (eventDate.end_date | validDate) &&
                                           (eventDate.start_time | validDate) &&
                                           (eventDate.end_time | validDate) &&
                                           (eventDate.start_date != eventDate.end_date ||
                                           (eventDate.start_time != eventDate.end_time  &&
                                           (eventDate.start_time | validDate) &&
                                           (eventDate.end_time | validDate))
                                           )"
                            > - </span>
                            <span ng-show="(eventDate.end_date | validDate) &&
                                           (eventDate.start_date != eventDate.end_date)">
                                {{ eventDate.end_date | amDateFormat:'L' }}
                            </span>
                            <span ng-show="eventDate.end_time != null"> {{ eventDate.end_time | amDateFormat:'hh:mma' }} </span>
                    </span>
                    <span ng-if="results.length === 0"> No Upcoming Dates.</span>

*/
